import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EncryptionDecryptionService } from './encryption-decryption.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public baseUrl: any = environment.baseUrl;
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  sessionItem: string | null;
  userObj: string;

  constructor(
    private http: HttpClient,
    private encryptDecrypt: EncryptionDecryptionService,
  ) {
    this.sessionItem = localStorage.getItem('currentUser');
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(this.sessionItem));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  initiateSamlLogin() {
    window.location.href = `${this.baseUrl}/auth/saml/login`;
  }
  setcurrentUserSubject(user: any) {
    this.currentUserSubject.next(user);
  }
  initializeSamlSession(token: string) {
    console.log('Calling session initialization API with token');
    return this.http.post(`${this.baseUrl}/auth/api/v1/saml/init-session`,
      { token: token },
      { withCredentials: true }
    );
  }
  authenticateUser(user: any, isLdap: boolean = false) {
    this.userObj = this.encryptDecrypt.setEncryption(user);
    let data = {
      'encryptedText': this.userObj
    };
    const endpoint = isLdap ? '/auth/api/v1/ldap' : '/auth/api/v1/mock';
    return this.http.post(`${this.baseUrl}${endpoint}`, data);
  }

  validateJwtToken(redirectUrl: any) {
    return this.http.get(redirectUrl);
  }


  getUserObject() {
    return this.http.get(`${this.baseUrl}/auth/api/v1/state.js`, {
      withCredentials: true
    });
  }

  // chnage
  getToken() {
    const headers = new HttpHeaders().set('Content-type', 'application/json; charset=utf-8')
    this.http.get(`${this.baseUrl}` + `/auth/mock/`, { headers: headers }).subscribe((response: any) => {

    });
  }

  logout(user: User) {
    return this.http.post("url", user);
  }

  updateLastLogindate(time: any, user: any) {


    const data = {
      lastlogintime: time,
      email: user.email
    }
    JSON.stringify(data);


    // return this.http.post(`${this.baseUrl}`+'/s/updateUserLoginTime',data).subscribe((res:any)=>{

    // });
    const payload = {
      // lastlogintime: time,
      email: user.email
    };
    const params = new URLSearchParams(payload).toString();
    const urlWithParams = `${this.baseUrl}` + '/s/updateUserLoginTime/' + user.email + '/';

    return fetch(urlWithParams, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate', // Forces the client not to cache
        'Pragma': 'no-cache',                                   // HTTP 1.0 backward compatibility
        'Expires': '0'                                          // Forces the response to expire
      },
      mode: "cors"
    });

  }

  changePass(email, password, oldPassword) {
    let data: any = {
      'oldPassword': oldPassword,
      'newPassword': password,
      'email': email
    }
    return this.http.post(`${this.baseUrl}` + '/api/v1/users/changePassword', data);
  }
}

